import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { propArrayShape, propBool, propShape, propFunc, propNumber, } from '../../../../helpers/custom-prop-types';
import SlideViewerLeftComponentImages from './SlideViewerLeftComponentImages';
const SlideViewerLeftComponent = (props) => {
    const { canCheck, imageIndex, images, onChangeSelectSlide, onClickImage: rawOnClickImage, selectMap, unit, } = props;
    const leftRef = useRef();
    const ref = useRef(0);
    const firstWidth = useRef();
    const imageTransfer = useRef();
    const imagesRef = useRef([]);
    // 画像クリック時のイベント
    const onClickImage = useCallback((e) => {
        const value = e.currentTarget.getAttribute('data-value');
        rawOnClickImage(parseInt(value, 10));
    }, [rawOnClickImage]);
    const onDragStart = useCallback((e) => {
        e.dataTransfer.setDragImage(imageTransfer.current, 0, 0);
        ref.current = e.clientX;
        firstWidth.current = leftRef.current.clientWidth;
    }, [ref, leftRef]);
    const onDrag = useCallback((e) => {
        const diff = e.clientX - ref.current;
        const width = firstWidth.current + diff;
        leftRef.current.style.width = `${width}px`;
    }, [leftRef, firstWidth]);
    const onDragEnd = useCallback((e) => {
        const diff = e.clientX - ref.current;
        const width = firstWidth.current + diff;
        leftRef.current.style.width = `${width}px`;
        ref.current = 0;
    }, [ref, leftRef, firstWidth]);
    useEffect(() => {
        imagesRef.current = imagesRef.current.slice(0, images.length);
    }, [images, imagesRef]);
    useEffect(() => {
        const imageBox = leftRef.current;
        const image = imagesRef.current[imageIndex];
        if (!imageBox || !image) {
            return;
        }
        const { bottom, top } = image.getBoundingClientRect();
        const { height } = imageBox.getBoundingClientRect();
        if (top < 0 || height < bottom) {
            imageBox.scrollTo({
                behavior: 'smooth',
                top: image.offsetTop,
            });
        }
    }, [imageIndex, imagesRef, leftRef]);
    return (_jsxs("div", Object.assign({ className: 'slide_viewer_left' }, { children: [_jsx(SlideViewerLeftComponentImages, { boxRef: leftRef, canCheck: canCheck, className: '', imageIndex: imageIndex, images: images, imagesRef: imagesRef, onChangeSelectSlide: onChangeSelectSlide, onClickImage: onClickImage, selectMap: selectMap, unit: unit }), _jsxs("div", Object.assign({ className: 'slide_viewer_left_clickable', onDrag: onDrag, onDragEnd: onDragEnd, onDragStart: onDragStart, role: 'presentation' }, { children: [_jsx("i", { className: 'css_equal_icon' }), _jsx("div", { className: 'slide_viewer_left_clickable_dummy', ref: imageTransfer })] }))] })));
};
SlideViewerLeftComponent.propTypes = {
    canCheck: propBool(),
    imageIndex: propNumber().isRequired,
    images: propArrayShape().isRequired,
    onChangeSelectSlide: propFunc(),
    onClickImage: propFunc().isRequired,
    selectMap: propShape(),
    unit: propShape(),
};
SlideViewerLeftComponent.defaultProps = {
    canCheck: false,
    onChangeSelectSlide: () => { },
    selectMap: null,
    unit: null,
};
export default SlideViewerLeftComponent;
